
import AboutHero from '../../../screens/customer/about/AboutHero';
import WhoWeAre from '../../../screens/customer/about/WhoWeAre';
import StatsSkills from '../../../screens/customer/about/StatsSkills';
import MyNavbar from '../../../components/customer/MyNavbar';
import Footer from '../../../components/customer/Footer';

const About = () => {
  return (
    <>
      <MyNavbar />
      <AboutHero />
      <WhoWeAre />
      <StatsSkills />
      <Footer />
    </>
  );
};

export default About;



 